import { vertiNodeAppName } from "../../../../core/schema/names/vertiNodeAppName.js";

export function createTitle(title?: string): string {
	return title ?? vertiNodeAppName;
}
